import { render, staticRenderFns } from "./InsufficientFundsDialog.vue?vue&type=template&id=ecad776c&scoped=true&"
import script from "./InsufficientFundsDialog.vue?vue&type=script&lang=js&"
export * from "./InsufficientFundsDialog.vue?vue&type=script&lang=js&"
import style0 from "./InsufficientFundsDialog.vue?vue&type=style&index=0&id=ecad776c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecad776c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
